import { render } from "./TheAuthNavbar.vue?vue&type=template&id=8165fff8&scoped=true&ts=true"
import script from "./TheAuthNavbar.vue?vue&type=script&lang=ts"
export * from "./TheAuthNavbar.vue?vue&type=script&lang=ts"

import "./TheAuthNavbar.vue?vue&type=style&index=0&id=8165fff8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8165fff8"]])

export default __exports__